<ng-container *ngIf="cart$ | async as cart">
  <ng-container *ngIf="entries$ | async as entries">
    <div *ngIf="cart.totalItems > 0" class="cart-details-wrapper">
      <cx-cart-validation-warnings></cx-cart-validation-warnings>

      <div class="header d-flex justify-content-between">
        <div>
          <h2 class="cx-total mr-3">
            {{ 'cartDetails.cartName' | cxTranslate: { code: cart.code } }}
          </h2>
          <span *ngIf="user?.uid && cart?.cartOwner !== user?.uid">Cart Owner: {{ cart.cartOwnerName }}</span>
        </div>
        <h3 *ngIf="cart.internalCalculation && !(isNetRestrictedPriceGroup$ | async)" class="offline">Offline</h3>
      </div>

      <cx-promotions
        [promotions]="
          (cart.appliedOrderPromotions || []).concat(
            cart.potentialOrderPromotions || []
          )
        "
      ></cx-promotions>

      <gen-cart-item-list
        [groups]="entries"
        [shippingGroups]="cart?.shippingGroups"
        [cartIsLoading]="!(cartLoaded$ | async)"
        [promotionLocation]="promotionLocation"
        [options]="{
          isSaveForLater: false,
          optionalBtn: saveForLaterBtn
        }"
      ></gen-cart-item-list>
    </div>
    <cx-clear-cart></cx-clear-cart>
  </ng-container>
</ng-container>

<ng-template let-ctx #saveForLaterBtn>
  <button
    *ngIf="selectiveCartEnabled"
    class="link cx-action-link cx-sfl-btn"
    [disabled]="ctx.loading"
    (click)="saveForLater(ctx.item)"
    type="button"
  >
    {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
  </button>
</ng-template>
